const _ = require('lodash');
const { getContext } = require('@fiverr-private/fiverr_context');
const { EventGroups } = require('../../../constants');
const { createBaseEvent } = require('../../base');
const { ACTION_TYPE, DEFAULT_SOURCE_INFO } = require('./constants');

const createBaseUserActionEvent = (type, {
    targetLocale,
    sourceInfo: { gig, user, ...page }
}) => {
    const { pageCtxId } = getContext();

    return createBaseEvent({
        type,
        group: EventGroups.userActions,
        user: _.merge({}, user, {
            locale: targetLocale
        }),
        gig,
        action: {
            type: ACTION_TYPE
        },
        page: _.merge(DEFAULT_SOURCE_INFO, { ctx_id: pageCtxId }, page)
    });};

module.exports = {
    createBaseUserActionEvent
};
